import PropTypes from "prop-types";
import React from "react";
import { CircularProgress } from "@mui/material";
import Typography from "./Typography";
import { StyledPageSpinner } from "../constants/styledComponents";

const PageSpinner = ({ color = "primary" }) => {

	return (
		<StyledPageSpinner>
			<CircularProgress color={color} />
			<Typography variant="h5" component="div"></Typography>
		</StyledPageSpinner>
	);
};

PageSpinner.propTypes = {
	color: PropTypes.oneOf(["primary", "secondary", "error", "warning", "info", "success"]),
};

export default PageSpinner;
